import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createBusiness } from '@app/services/business';
import { fetchMe } from '@app/redux/features/auth';
import { useAppDispatch } from '@app/redux/hooks';
import { toast } from 'react-toastify';

const planNameMap: Record<string, string> = {
  starter: 'FREE',
  professional: 'PRO',
  enterprise: 'GROWTH',
};

export const useWelcomeExistingPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [selectedPlan, setSelectedPlan] = useState<string | null>(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleChoosePlan = async () => {
    if (isProcessing || !selectedPlan) return;

    setIsProcessing(true);

    try {
      const stored = localStorage.getItem('pendingBusinessData');
      if (!stored) {
        toast.error('Business data not found. Please try again.');
        navigate('/select-business/create-new');
        return;
      }

      const businessData = JSON.parse(stored);
      const planName = planNameMap[selectedPlan] || selectedPlan.toUpperCase();

      await createBusiness({
        ...businessData,
        planName,
        isTrial: false,
      });

      await dispatch(fetchMe());

      localStorage.removeItem('pendingBusinessData');
      localStorage.removeItem('selectedPlan');

      navigate('/select-business?new=true');
    } catch (err: any) {
      const errorData = err?.data || err?.response?.data;
      const message = errorData?.message;

      if (message?.includes('phone number already exists')) {
        toast.error('This phone number is already used by another business.');
      } else if (errorData?.name == 'plan_exeeded') {
        // toast.warning(message + ' Click to upgrade your plan!', {
        //   onClick: () => {
        //     navigate('/settings?tab=plan');
        //   },
        //   autoClose: false,
        // });
        toast.warning(message + ' Please, upgrade your plan!', { autoClose: false, position: 'top-center', });
      } else if (errorData?.type == 'custom_error') {
        toast.error(message);
      } else {
        toast.error('Error while creating your business. Please try again.');
      }
    } finally {
      setIsProcessing(false);
    }
  };

  return {
    navigate,
    handleChoosePlan,
    isProcessing,
    selectedPlan,
    setSelectedPlan,
  };
};
